
import { BiSolidMessageError } from "react-icons/bi";
export const CONTEXT_HEADING = "KGBV" //  DSC
export const CONTEXT_NAME = 'AP KGBV RECRUITMENT';
export const CONTEXT_COMMON_NAME = 'AP KGBV RECRUITMENT'
export const ACADEMIC_YEAR = '2026';
export const CURRENT_ACADEMIC_YEAR = 2026;
export const public_url = 'kgbv-public/'
export const ERROR_MSG = (<b><BiSolidMessageError size={18} />  Required</b>)
export const ALPHABETS_ONLY_Msg = "Enter Only letters";
export const NUMERIC_Msg = "Enter Only Numbers";
export const Aadhaar_Msg = "Invalid Aadhaar!";
export const Mobile_Msg = "Invalid Mobile No. !";
export const HT_Msg = "Invalid Hall Ticket No. !";
export const Addres_Msg = "Dont Use Special Characters";
export const Percentage_Msg = "Enter valid percentage of marks minimum 35%";
export const PWD_REG = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{8,}$/
export const USERNAME_REG = /^MDSC\d{7}$/;
export const alphaNumeric_VALIDATION = /^[a-zA-Z0-9]*$/;
export const Percentage_Validation = /^(45(\.[0-9])?|4[6-9](\.[0-9])?|[5-9][0-9](\.[0-9])?|100(\.0)?)$/;
export const Percentage_Validation_35 = /^(35(\.[0-9])?|3[6-9](\.[0-9])?|[5-9][0-9](\.[0-9])?|100(\.0)?)$/;
export const Percentage_Validation_50 = /^(50(\.[0-9])?|[5-9][0-9](\.[0-9])?|100(\.0)?)$/;
export const IFSC_VALIDATION = /^[A-Z]{4}0[A-Z 0-9]{6}$/;
export const AADHAR_VALIDATION = /^[2-9]{1}[0-9]{11}$/
export const MOBILE_VALIDATION = /^[6-9]{1}[0-9]{9}$/;
export const PAN_VALIDATION = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const APPINCODE = /^5[0-9]{5}$/;
export const PINCODE = /^[1-9]{1}[0-9]{5}$/;
export const ONLY_NUMERIC = /^[0-9]+$/;
export const ONLY_CAPS = /^[A-Z\s]+$/;
export const NUMERIC = /^\d+$/;
export const ALPHABETS_ONLY = /^[A-Za-z\s]+$/;
export const ALPHABETS_DOT_ONLY = /^[A-Za-z.\s]+$/;
export const ALPHABETS_DOT_ONLY_Msg = "Only alphabets, spaces, and dot (.) are allowed";
export const STARTS_WITH_NO_WHITESPACE = /^(?!\s+$).*/;
export const AddresRemarks = /^[0-9a-zA-Z\s,.$%#@-]+$/;
export const tet_marks = /^(60(\.[0-9])?|4[6-9](\.[0-9])?|[5-9][0-9](\.[0-9])?|100(\.0)?)$/;

export const handleKeyPressNumeric = (e) => {
    const allowedChars = /^[0-9]$/;
    if (!allowedChars.test(e.key)) {
        e.preventDefault();
    }
};

// export const handleNumericDot = (e) => {
//     const allowedChars = /^[0-9.]$/;
//     if (!allowedChars.test(e.key)) {
//         e.preventDefault();
//     }
// };
export const getMinPercentage = (caste, isPh) => {
  if (isPh === "true") return 40;

  const casteMap = {
    OC: 50,
    "BC-A": 45,
    "BC-B": 45,
    "BC-C": 45,
    "BC-D": 45,
    "BC-E": 45,
    SC: 40,
    ST: 40,
  };

  return casteMap[caste] || 35;
};
export const getPercentageErrorMsg = (caste, isPh) => {
  const min = getMinPercentage(caste, isPh);
  return `Minimum ${min}% required`;
};
export const validatePercentageByCaste = (value, caste, isPh) => {
  if (!value) return false;

  const isValidFormat = /^(\d+)(\.\d{1})?$/.test(value);
  if (!isValidFormat) return false;
  const num = parseFloat(value);
  const min = getMinPercentage(caste, isPh);

  if (num < min || num > 100) return false;

  return true;
};
export const handleNumericDot = (e) => {
  let value = e.target.value;

  value = value.replace(/[^0-9.]/g, "");

  const parts = value.split(".");
  if (parts.length > 2) {
    value = parts[0] + "." + parts.slice(1).join("");
  }

  e.target.value = value;
};
export const handleKeyAlphaNumeric = (e) => {
    if (e.key === "Enter") {
        e.preventDefault();
        return;
    }

    if (!alphaNumeric_VALIDATION.test(e.key)) {
        e.preventDefault();
    }
};
export const handleKeyPressAlphabets = (e) => {

    if (!ALPHABETS_ONLY.test(e.key)) {
        e.preventDefault();
    }
};
export const handleKeyPressAlphabetsDot = (e) => {

    if (!ALPHABETS_DOT_ONLY.test(e.key)) {
        e.preventDefault();
    }
};
export const handleInputToUppercase = (e) => {
    e.target.value = e.target.value.toUpperCase();
};